module.exports = __webpack_public_path__ + "img/hnsrmjcy.5cdacfef.png";